<template>
	<div class="shadow-md outline-2 outline-grey-700 rounded px-2 py-2">
		<!-- * selection du service -->
		<b-dropdown
			:text="
				Object.keys(values.selectedService).length > 0
					? values.selectedService.libelle
					: 'Service'
			"
			class="m-md-2">
			<b-dropdown-item
				v-for="service in services"
				:key="service.uid"
				@click="() => updateServiceURL(service)">
				{{ service.libelle }}
			</b-dropdown-item>
		</b-dropdown>
		<!-- * config de requete -->
		<div v-if="Object.keys(values.selectedService).length > 0">
			<!-- * info intercalage de valeurs colonnes  -->
			<div
				style="cursor: pointer"
				class="d-flex justify-center align-items-center w-fit mb-2"
				@click="details_open = !details_open">
				<div
					style="font-size: large"
					class="align-text-bottom w-100 m-1 rounded-lg">
					Info
				</div>
				<i
					style="transition-duration: 0.5s"
					:style="{
						transform: details_open ? 'rotate(-180deg)' : '',
					}"
					class="fas fa-chevron-down"></i>
			</div>

			<!-- * Ancien conteneur de détails -->
			<b-collapse id="collapseInfos" v-model="details_open">
				<div class="flex justify-center items-center mt-2">
					Dans l'éditeur de scénarios,
					<br />
					pour utiliser la valeur d'une colonne dans l'URL, utilisez
					cette syntaxe:
					{{ "https://example.com/${data.colonne_example}" }}
				</div>
			</b-collapse>

			<!-- * barre d'URL -->
			<div class="flex justify-center items-center my-3">
				<!-- * dropdown du verbe -->
				<b-dropdown :text="values.verb" class="m-md-2">
					<b-dropdown-item
						v-for="verb in verbs"
						:key="verb"
						@click="() => (values.verb = verb)">
						{{ verb }}
					</b-dropdown-item>
				</b-dropdown>
				<!-- * input de l'url -->
				<!-- todo j'arrive pas à changer la grandeur de la ligne -->
				<input
					v-b-tooltip.hover="{
						variant: 'info',
						title: 'Laissez vide pour prendre la colonne uri par défaut',
					}"
					class="w-50 shadow rounded leading-relaxed border-t-0 border-r-0 border-l-0 focus:outline-none focus:shadow-outline focus:border-gray-900 focus:border-b-2"
					type="text"
					v-model="values.url" />
				<!-- * bouton pour test la requete -->
				<b-button
					class="m-md-2"
					variant="outline-primary"
					@click="() => testCall()">
					Test
				</b-button>
			</div>

			<!-- * configuration du temps d'attente -->
			<div class="mb-2">
				Temps d'attente entre deux requêtes (ms)
				<br />
				<input
					min="0"
					class="w-25 shadow rounded leading-relaxed border-t-0 border-r-0 border-l-0 focus:outline-none focus:shadow-outline focus:border-gray-900 focus:border-b-2"
					type="number"
					v-model="values.timeBetweenRequests" />
			</div>
			<b-tabs>
				<b-tab title="Requête">
					<config-champs-requete
						field-name="paramètre"
						v-model="values.queryParams" />
				</b-tab>
				<b-tab title="Headers">
					<config-champs-requete
						field-name="header"
						v-model="values.headers" />
				</b-tab>
				<b-tab title="Body">
					<config-champs-requete
						field-name="champ"
						v-model="values.body" />
				</b-tab>
				<b-tab title="Form">
					<config-champs-requete
						field-name="champ"
						v-model="values.form" />
				</b-tab>
				<b-tab title="FormData">
					<b-form-checkbox v-model="values.formData.envoiFichiers">
						Envoyer le fichier d'entrée
					</b-form-checkbox>
					<b-form-checkbox v-model="values.formData.reponseFichiers">
						Récupérer le fichier de sortie
					</b-form-checkbox>
				</b-tab>
			</b-tabs>

			<div
				v-if="requestResult.status !== -1"
				class="shadow-md outline-2 outline-grey-700 rounded px-2 py-2">
				<!-- * spinner -->
				<b-spinner
					v-if="requestResult.status === 202"
					label="Spinning"></b-spinner>
				<div v-if="requestResult.status === 200">
					<pre class="input-color">
                        <code>
                            {{ requestResult.value }}
                        </code>
                    </pre>
				</div>
				<div class="text-red-600" v-if="requestResult.error">
					{{ requestResult.error }}
				</div>
			</div>
		</div>
	</div>
</template>

<!-- todo | le plus beau ce serait de mettre à jour l'URL lorsqu'on modifie les params et vice versa
     todo | cf design ThunderClient
-->

<script>
	import workers from "../services/workers.js";
	import treatments from "../services/treatments.js";
	import element from "../services/element.js";

	import config_champs_requete from "./config_champs_requete.vue";

	export default {
		name: "appel_service_type",
		components: {
			"config-champs-requete": config_champs_requete,
		},
		data() {
			return {
				values: {
					timeBetweenRequests: 0,
					selectedService: {},
					url: "http://example.com/",
					verb: "GET",
					queryParams: [
						{
							parameter: "",
							value: "",
							col: false,
							description: "",
						},
					],
					headers: [
						{
							parameter: "",
							value: "",
							col: false,
							description: "",
						},
					],
					body: [
						{
							parameter: "",
							value: "",
							col: false,
							description: "",
						},
					],
					form: [
						{
							parameter: "",
							value: "",
							col: false,
							description: "",
						},
					],
					formData: {
						envoiFichiers: false,
						reponseFichiers: false,
					},
					// auth ?
				},
				data_db: {},
				verbs: ["GET", "POST", "PUT", "DELETE", "PATCH"],
				services: [],
				requestResult: {
					status: -1,
					value: {},
					error: null,
				},
				details_open: false,
			};
		},
		watch: {},
		methods: {
			async updateServiceURL(newVal) {
				this.values.headers = [
					{ parameter: "", value: "", col: false, description: "" },
				];

				this.values.selectedService = newVal;

				let serviceInfo = await element.load(
					newVal.libelle,
					newVal.version,
					"service"
				);

				this.values.url = serviceInfo.parameters.url;

				serviceInfo.parameters.keyNames.forEach((keyName) => {
					if (keyName.keyName.length > 0) {
						this.values.headers.push({
							parameter: "API_KEY",
							value: keyName.keyName,
							col: false,
							description: "",
						});
					}
				});

				this.data_db.serviceLabel = newVal.libelle;
			},
			async save() {
				let data = {
					parameters: this.values,
					data_db: this.data_db,
				};

				return data;
			},
			async load(data) {
				this.values = data.parameters;
				this.data_db = data.data_db;
			},
			generateAPIObject(url) {
				let finalObject = {
					action: "api",
					label: "API",
					parameters: {
						method: this.values.verb.toLowerCase(),
						files: false, // * à voir comment utiliser avec les fichiers dans le body
						response_file: false, // * case à cocher ?
						// qs: [],
						// qs_params: {},
						// body: [],
						// body_params: {},
						// headers: [],
						headers_params: {},
						// form_params: {},
						uri: url,
					},
				};

				let fields = ["headers", "body", "form"];

				// * on assigne les valeurs à l'objet final
				fields.forEach((field) => {
					this.values[field].forEach((element) => {
						// * si on a précisé un param et que c'est pas une colonne (dans cet editeur on n'a pas accès aux colonnes)
						if (element.parameter !== "" && !element.col) {
							if (
								!finalObject.parameters.hasOwnProperty(
									field + "_params"
								)
							)
								finalObject.parameters[field + "_params"] = {};

							finalObject.parameters[field + "_params"][
								element.parameter
							] = element.value;
						}
					});
				});

				return finalObject;
			},
			async testCall() {
				this.requestResult = {
					status: -1,
					value: {},
					error: null,
				};

				// * faire un appel avec les valeurs de la requete
				let requestURL = this.values.url;

				for (let i = 0; i < this.values.queryParams.length; i++) {
					const queryParam = this.values.queryParams[i];

					if (queryParam.parameter != "" && queryParam.value != "") {
						// * un '?' si c'est le premier param sinon '&'
						if (requestURL.indexOf("?") === -1) requestURL += "?";
						else requestURL += "&";
						requestURL +=
							queryParam.parameter + "=" + queryParam.value;
					}
				}

				let workerData = this.generateAPIObject(requestURL);

				// * may need to convert to formData ?
				var formData = new FormData();
				Object.keys(workerData).forEach((key) =>
					formData.set(
						key,
						typeof workerData[key] === "object"
							? JSON.stringify(workerData[key])
							: workerData[key]
					)
				);
				this.requestResult.status = 202;

				let results = await workers.test(formData);

				// * call the worker

				var blob = await treatments.getFileAlyx(
					results.data.files[0].url,
					false,
					false
				);
				let fileName = results.data.files[0].name;
				let finalObject = blob;

				if (fileName.endsWith(".csv")) {
					finalObject = this.$papa.parse(blob, { header: true });
					finalObject = finalObject.data[0].result;
				} else {
					finalObject = blob[0].result;
				}

				try {
					if (finalObject.length > 0) {
						//console.log("Got result: ", finalObject);
						finalObject = JSON.parse(finalObject);

						// todo parse JSON with an extension ? cf JSONLINT
						// finalObject = JSON.stringify(finalObject, null, 2);
						// * arguments: objet, fonction d'indentation, charactere d'indentation
						finalObject = JSON.stringify(finalObject, null, 4);
						finalObject = "\n" + finalObject;
					} else {
						console.log("Empty return");
					}
				} catch (error) {
					this.requestResult.value = "Error: " + error;
					console.log("Could not parse JSON ", error);
				}

				// console.log("Final result from worker");
				// console.log(finalObject);

				this.requestResult.status = results.status;
				this.requestResult.error = results.error;
				this.requestResult.value = finalObject;
			},
		},
		mounted: async function () {
			this.services = (await element.getby_production("service")).element;

			//console.log("Got available services", this.services);
		},
	};
</script>

<style></style>
